import { useIovation, approveTerms } from 'shared';
import { usePostConsumerApplicationsV2CreditApplicationsApplyAfterPrequalificationMutation } from 'consumer-applications-v2-api';
const useWaterfallEDS = () => {
    const [getBlackboxData] = useIovation();
    const [postApplyAfterPrequal, { data: dataApplyAfterPrequalResp, isLoading: isLoadingApplyAfterPrequal },] = usePostConsumerApplicationsV2CreditApplicationsApplyAfterPrequalificationMutation();
    const getApplyAfterPrequalArgs = (offer, applicationId) => {
        const acceptedOffer = offer;
        const { offerId: acceptedOfferId, terms: acceptedOfferTerms } = acceptedOffer ?? { offerId: 0, terms: [] };
        const blackboxData = getBlackboxData();
        const approvedTerms = acceptedOfferTerms
            ? approveTerms(...acceptedOfferTerms)
            : [];
        const application = {
            applicationId,
            acceptedOfferId,
            iovationBlackBox: blackboxData.blackbox,
            prerequisiteTermsAccepted: approvedTerms,
        };
        return application;
    };
    return {
        dataApplyAfterPrequalResp,
        isLoadingApplyAfterPrequal,
        postApplyAfterPrequal,
        getApplyAfterPrequalArgs,
    };
};
export default useWaterfallEDS;
